const secure = '(/secure/|/)';
const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
export const legacyDashboardsDeleteRoute = {
	name: 'legacy-dashboards-delete',
	path: `${secure}DeletePortalPage${defaultSuffix}.jspa`,
};
